<div class="reposts-modal-container">
  <div
    class="w-100 d-flex justify-content-end border-bottom border-color-grey cursor-pointer text-grey5"
  >
    <div class="p-15px fs-25px font-weight-bold" (click)="bsModalRef.hide()">
      &times;
    </div>
  </div>

  <div class="flex-grow-1">
    <div #uiScroll *uiScroll="let profile of datasource">
      <simple-profile-card
        [profile]="profile"
        [showRepostIcon]="true"
        [containerModalRef]="bsModalRef"
      ></simple-profile-card>
    </div>
  </div>

  <simple-center-loader *ngIf="loading"></simple-center-loader>
</div>
